function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)",
  fill: "#14315C"
}, /*#__PURE__*/React.createElement("rect", {
  transform: "rotate(-45 -361.31 416.84)",
  x: -361.31,
  y: 416.84,
  width: 589.95,
  height: 589.95,
  rx: 40,
  opacity: 0.08
}), /*#__PURE__*/React.createElement("rect", {
  transform: "rotate(-45 -150.41 314.46)",
  x: -150.41,
  y: 314.46,
  width: 294.98,
  height: 294.98,
  rx: 24,
  opacity: 0.08
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M473 250H40C17.9086 250 0 232.091 0 210V0H473V250Z",
  fill: "#fff"
})));

var SvgLandingCornerBottom = function SvgLandingCornerBottom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 473 250",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLandingCornerBottom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/landing-corner-bottom.cab9ad74.svg";
export { ForwardRef as ReactComponent };